import Controller from "./event.controller";
import template from "./event.html";

const event = {
  template,
  controller: Controller,
};

export default event;



// WEBPACK FOOTER //
// ./src/pages/event/event.component.js